const ITEMS = [
  "POP-UP PICKLEBALL",
  "MELBOURNE METRO",
  "CORPORATE TEAM DAYS",
  "JOOLA PRO SURFACING",
  "SHOPPING CENTRES",
  "COUNCIL ACTIVATIONS",
  "FASTEST GROWING SPORT",
  "SCHOOL HOLIDAY PROGRAMS",
  "BRAND ACTIVATIONS",
  "END OF YEAR EVENTS",
];

export default function Marquee() {
  return (
    <div className="relative -mx-2 -rotate-1 overflow-hidden border-y-4 border-obsidian bg-volt py-3" data-testid="editorial-marquee">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
              <span
                key={`${half}-${item}`}
                className="flex items-center font-display text-2xl font-extrabold uppercase tracking-tight text-obsidian sm:text-3xl"
              >
                <span className="px-6">{item}</span>
                <span className="h-2 w-2 rounded-full bg-obsidian" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
